import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import UnderConstruction from "./pages/UnderConstruction";
import { siteConfig } from "./config/siteConfig";

function App() {
  const home = siteConfig.features.underConstructionMode ? (
    <UnderConstruction />
  ) : (
    <HomePage />
  );

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={home} />
          <Route path="/under-construction" element={<UnderConstruction />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
